import type { MotionValue } from 'framer-motion';
import { createContext, Dispatch, SetStateAction } from 'react';
import type { FileWorkerStaleDuckType } from './_file_worker_stale_duck_type';

export interface FileViewerContextValue {
	readonly isOpen: boolean;
	readonly setIsOpen: Dispatch<SetStateAction<boolean>>;
	readonly files: FileWorkerStaleDuckType[];
	readonly setFiles: Dispatch<SetStateAction<FileWorkerStaleDuckType[]>>;
	readonly hasDisabledScroll: boolean;
	readonly setHasDisabledScroll: Dispatch<SetStateAction<boolean>>;
	readonly startIndex: number;
	readonly setStartIndex: Dispatch<SetStateAction<number>>;
	readonly showBar: boolean;
	readonly setShowBar: Dispatch<SetStateAction<boolean>>;
	readonly showBarManually: boolean;
	readonly setShowBarManually: Dispatch<SetStateAction<boolean>>;
	readonly showDownload: boolean;
	readonly currentIndex: number;
	readonly setCurrentIndex: Dispatch<SetStateAction<number>>;
	readonly y: MotionValue<number>;
	readonly goToPrevious: () => void;
	readonly goToNext: () => void;
	readonly onDownloadError?: () => void;
}

export const FileViewerContext = createContext<FileViewerContextValue>(undefined as unknown as FileViewerContextValue);
